import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';
import Button from 'components/common/Button';
import IconArrowLeft from 'components/icons/IconArrowLeft';

import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  title: {
    display: 'inline-flex',
    maxWidth: '100%',
    alignItems: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: 10,
    margin: -10,
    verticalAlign: 'top',
  },
  titleWhite: {
    color: theme.palette.common.white,
  },
  titleText: {
    alignItems: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: pxToRem(22),
  },
  button: {
    marginRight: 24,
    width: 30,
    height: 30,
    minHeight: 30,
    '& $iconArrowLeft': {
      marginRight: 0,
    },
  },
  iconArrowLeft: {
    width: 16,
    height: 16,
    marginRight: 18,
  },
  link: {
    display: 'block',
  },
});

const PageTitle = ({
  text,
  href,
  className,
  goBack,
  variant,
  color,
  history,
  classes,
  ref,
}) => {
  const title = (
    <Typography
      variant="title"
      className={classNames(classes.title, {
        [classes.titleWhite]: color === 'white',
      })}
      ref={ref}
    >
      {((href || goBack) && variant === 'default') &&
        <IconArrowLeft className={classes.iconArrowLeft} />
      }
      {((href || goBack) && variant === 'button') &&
        <Button
          variant="fab"
          className={classes.button}
          {...goBack
            ? { onClick: () => { history.goBack(); } }
            : { href }
          }
        >
          <IconArrowLeft className={classes.iconArrowLeft} />
        </Button>
      }
      <div className={classes.titleText}>{text}</div>
    </Typography>
  );
  return (
    <div className={className}>
      {((href || goBack) && variant === 'default') ? (
        <Link
          className={classes.link}
          {...goBack
            ? { onClick: () => { history.goBack(); } }
            : { href }
          }
        >
          {title}
        </Link>
      ) : (
        title
      )}
    </div>
  );
};

PageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  className: PropTypes.string,
  goBack: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'button']),
  color: PropTypes.oneOf(['default', 'white']),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  ref: PropTypes.func,
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
    titleText: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconArrowLeft: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

PageTitle.defaultProps = {
  href: null,
  className: '',
  goBack: false,
  variant: 'default',
  color: 'default',
  ref: () => {},
};

export default withRouter(
  withStyles(styles)(PageTitle),
);



// WEBPACK FOOTER //
// ./src/components/common/PageTitle.js